(() => {
  document.querySelectorAll('.gp-accordion-item_header').forEach(button => {
    button.addEventListener('click', () => {
      const open = button.getAttribute('aria-expanded') !== 'true';
      const body = document.getElementById(button.getAttribute('aria-controls'));
      button.setAttribute('aria-expanded', String(open));
      body.setAttribute('aria-hidden', String(!open));
      body.inert = !open;
    });
  });
  const sticky = document.querySelector('[data-tm-sticky]');
  const start = document.querySelector('.eEiqNXXvvtOZ');
  const stop = document.querySelector('.gB_PfnVaHk');
  let pending = false;
  const update = () => {
    pending = false;
    if (!sticky || !start || !stop) return;
    const show = start.getBoundingClientRect().top < 0 && stop.getBoundingClientRect().top > window.innerHeight;
    sticky.classList.toggle('is-visible', show);
  };
  const schedule = () => { if (!pending) { pending = true; requestAnimationFrame(update); } };
  addEventListener('scroll', schedule, { passive: true });
  addEventListener('resize', schedule, { passive: true });
  update();
  // Carry attribution into the local store without retaining the USA trybe experiment.
  const query = new URLSearchParams(location.search);
  const allowed = [...query].filter(([name]) => /^utm_/.test(name) || ['fbclid', 'gclid', 'ttclid'].includes(name));
  document.querySelectorAll('a[data-tm-product-link]').forEach(link => {
    const url = new URL(link.href);
    for (const [name, value] of allowed) url.searchParams.set(name, value);
    link.href = url.href;
  });
})();
